import { DepartmentDto } from "../api";
import { plan2plateIcons } from "../utils/iconUtils";

export const getDepartmentIcon = (
  department: string,
): keyof typeof plan2plateIcons => {
  switch (department) {
    case "FRUITS_AND_VEGETABLES":
      return "banana";
    case "DAIRY_AND_EGGS":
      return "cheese";
    case "COOKING_AND_BAKING":
      return "cupcake";
    case "MEAT_AND_FISH":
      return "chickenLeg";
    case "FROZEN_FOOD":
      return "iceCreamCone";
    case "BREAD_CEREALS_SPREADS":
      return "jamJar";
    case "SWEETS_AND_SNACKS":
      return "popcorn";
    case "READY_MEALS_AND_CANNED_FOOD":
      return "pizzaSlice";
    case "COLD_CUTS":
      return "sausage";
    case "COFFEE_TEA_COCOA":
      return "teaCoffee";
    case "BEVERAGES_AND_TOBACCO":
      return "wineBottleGlass";
    case "NUTS":
      return "turnip";
    case "OILS_AND_SPICES":
      return "jug";
    case "SAUCES":
      return "sauceBottle";
    case "VEGAN":
      return "plantHeart";
    case "ONLINE":
      return "gear";
    case "FRESH_PASTA":
      return "wheat";
    default:
      throw new Error(`Unknown department ${department}`);
  }
};

export type Department = DepartmentDto;
